import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const clientsStartRequest = () => {
  return {
    type: 'CLIENTS_START_REQUEST'
  };
};

export const clientsEndRequest = () => {
  return {
    type: 'CLIENTS_END_REQUEST'
  };
};

export const getAllClientsSuccess = ({ data }) => {
  return {
    type: 'CLIENTS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllClientsError = error => {
  return {
    type: 'CLIENTS_GET_ALL_ERROR',
    payload: error
  };
};

export const addClientsSuccess = ({ data }) => {
  return {
    type: 'CLIENTS_ADD_SUCCESS',
    payload: data
  };
};

export const addClientsError = error => {
  return {
    type: 'CLIENTS_ADD_ERROR',
    payload: error
  };
};

export const editClientsSuccess = ({ data }) => {
  return {
    type: 'CLIENTS_EDIT_SUCCESS',
    payload: data
  };
};

export const editClientsError = error => {
  return {
    type: 'CLIENTS_EDIT_ERROR',
    payload: error
  };
};

export const removeClientsSuccess = id => {
  return {
    type: 'CLIENTS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeClientsError = error => {
  return {
    type: 'CLIENTS_REMOVE_ERROR',
    payload: error
  };
};

export const clientsModifyStore = ({ data }) => {
  return {
    type: 'CLIENTS_MODIFY_STORE',
    payload: data
  };
};

export const addClients = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(clientsStartRequest());
      const response = await api().post('/api/clients', data);
      dispatch(addClientsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'clients',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addClientsError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(clientsEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllClients = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(clientsStartRequest());
      const response = await api().get('/api/clients', { params });
      dispatch(getAllClientsSuccess(response));
    } catch (err) {
      dispatch(getAllClientsError(err));
    } finally {
      dispatch(clientsEndRequest());
    }
  };
};

export const editClients = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(clientsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(clientsStartRequest());
      const id = data._id;
      const { additionalInformation } = data;
      if (additionalInformation.trim() && id) {
        const user = JSON.parse(localStorage.getItem('user'));
        const contactHistory = {
          user: user._id,
          client: id,
          date: new Date(),
          content: additionalInformation
        };
        await api().post('/api/contacts_history/', contactHistory);
      }
      const response = await api().put('/api/clients/' + id, data);
      dispatch(editClientsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'clients',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/clients'));
      }
    } catch (err) {
      dispatch(editClientsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeClients = id => {
  return async dispatch => {
    try {
      dispatch(clientsStartRequest());
      await api().delete('/api/clients/' + id);
      dispatch(removeClientsSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'clients',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Cliente removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeClientsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover cliente.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(clientsEndRequest());
    }
  };
};

export const restoreClients = data => {
  return async dispatch => {
    try {
      dispatch(clientsStartRequest());
      const id = data._id;
      const response = await api().put('/api/clients/' + id, data);
      dispatch(editClientsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'clients',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Cliente restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editClientsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar cliente.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(clientsEndRequest());
    }
  };
};
